export default "https://cdn-static.gokick.com/assets/5a032fdfc840f3d1fce44ec205c52ed2ca8e0677/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";